import React from 'react';
import { Page, Document, Image, View, StyleSheet } from '@react-pdf/renderer';
import InvoiceTitle from './InvoiceTitle'
import InvoiceAddress from './InvoiceAddress'
import AgentName from './AgentName'
import InvoiceLine from './InvoiceLine'
import AgentImage from './AgentImage'
import BillTo from './BillTo'
import BillVoucher from './BillVoucher'
import AgentTo from './AgentTo'
import AgentDetails from './AgentDetails'
import GuestTo from './GuestTo'
import GuestDetails from './GuestDetails'
import InvoiceNo from './InvoiceNo'
import InvoiceItemsTable from './InvoiceItemsTable'
import TotalVoucher from './TotalVoucher'
import InvoiceThankYouMsg from './InvoiceThankYouMsg'
import InvoiceEmergency from './InvoiceEmergency'
import AgentItemsTable from './AgentItemsTable'
//import logo from './../../../../src/public/images/logo/seyLogo.png';



const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 8,
        paddingTop: 30,
        paddingLeft:60,
        paddingRight:60,
        lineHeight: 1,
        flexDirection: 'column',
    }, 
    logo: {
        width: 74,
        height: 66,
         marginBottom: -70,
    },
    agentlogo: {
        width: 66,
        height: 50,
        marginRight: 0,
        marginLeft: 400,
    },
    logoCombine: {
        display: 'flex',
        textAlign: 'center',
        justifyContent: 'space-between'
    },
    logo_footer: {
        width: 70,
        height: 40,
    },
   
    title: {
        marginTop: 20,
        fontFamily: 'Helvetica-Oblique',
        marginBottom: 0,
    },
    topallign:{
        marginTop: 10,
    }
  });
  
  const Invoice = ({invoice}) => (
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.logoCombine}>
                    <AgentImage invoice={invoice} />
                    <BillVoucher style={styles.agentlogo} invoice={invoice}/>
                    {/* <Image style={styles.agentlogo}  src="images/logo/seyLogo.png"  /> */}
                    </View>
                    {/* <InvoiceTitle  style={styles.title}  title='Booking Voucher'/> */}
                    <InvoiceLine />
                    <AgentName  invoice={invoice} />
                    {/* <BillVoucher invoice={invoice}/>
                    <InvoiceAddress /> */}
                    {/* <InvoiceLine /> */}
                    <BillTo invoice={invoice}/>
                    {/* <InvoiceNo invoice={invoice}/> */}
                    <InvoiceItemsTable invoice={invoice} />
                    <TotalVoucher invoice={invoice}/>
                     {/* <GuestTo invoice={invoice} /> */}
                   {/* <GuestDetails invoice={invoice} /> */}
                    {/* <AgentTo invoice={invoice} /> */}
                    {/* <AgentDetails invoice={invoice} /> */}
                    {/* <AgentItemsTable invoice={invoice} /> */}
                    {/* <InvoiceLine /> */}
                    <InvoiceEmergency />
                    <InvoiceThankYouMsg />
                    <Image style={styles.logo_footer}  src="images/logo/seyLogo.png" />
                </Page>
            </Document>
        );
  
  export default Invoice